export const isDigit = (digit: string) => {
    try {
        return /^\d+$/.test(digit);
    } catch {
        return false;
    }
};
